/*
 * cx-buy-now.js
 * Boton "Comprar ahora" de la ficha de producto.
 *
 * Agrega la variante seleccionada y lleva directo a /cart (la pagina con datos
 * y envio), saltandose el cart drawer. Acordado con Piero el 12/08/2026.
 *
 * Deliberadamente aislado: el boton es type="button" con su propio handler, asi
 * que no pasa por <product-form> ni por el flujo de carrito del equipo de Piero.
 */
(function () {
  'use strict';

  function route(path) {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + path;
  }

  function setBusy(btn, busy) {
    btn.classList.toggle('cx-buy-now--loading', busy);
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
    btn.disabled = busy;
  }

  function showError(btn, message) {
    var form = document.getElementById(btn.getAttribute('data-form'));
    var wrapper = form && form.closest('product-form');
    var box = wrapper && wrapper.querySelector('.product-form__error-message-wrapper');
    var target = box && box.querySelector('.product-form__error-message');

    if (!target) {
      window.alert(message);
      return;
    }
    target.textContent = message;
    box.hidden = false;
  }

  function clearError(btn) {
    var form = document.getElementById(btn.getAttribute('data-form'));
    var wrapper = form && form.closest('product-form');
    var box = wrapper && wrapper.querySelector('.product-form__error-message-wrapper');
    if (box) box.hidden = true;
  }

  function formOf(btn) {
    return document.getElementById(btn.getAttribute('data-form'));
  }

  function variantInputOf(form) {
    return form && form.querySelector('.product-variant-id, [name="id"]');
  }

  function variantIsUnavailable(form) {
    var variantInput = variantInputOf(form);
    return (
      !variantInput ||
      !variantInput.value ||
      variantInput.getAttribute('data-variant-available') === 'false'
    );
  }

  /*
   * El snippet marca el boton como deshabilitado si la variante inicial no
   * esta disponible, pero eso solo corre al renderizar. Si el cliente cambia
   * de talla sin recargar, el boton quedaba activo y dejaba comprar una talla
   * agotada.
   *
   * En vez de repetir la logica de inventario, se refleja el estado del boton
   * "Anadir al carrito" del theme: el theme ya sabe cuando una combinacion
   * esta agotada, en preventa o no existe. Si el suyo esta deshabilitado, el
   * nuestro tambien. La visibilidad del bloque la controla theme.js; aqui solo
   * se mantiene el estado accesible del boton cuando ese bloque esta visible.
   */
  function addButtonOf(btn) {
    var form = formOf(btn);
    if (!form) return null;
    var wrapper = form.closest('product-form') || form.parentElement;
    return (wrapper || form).querySelector('[name="add"]');
  }

  function sync(btn) {
    var form = formOf(btn);
    var add = addButtonOf(btn);
    if (!add) return;
    // Si esta cargando su propio pedido no se toca, para no pisar setBusy.
    if (btn.classList.contains('cx-buy-now--loading')) return;

    var bloqueado = !!(
      add.disabled ||
      add.getAttribute('aria-disabled') === 'true' ||
      variantIsUnavailable(form)
    );
    var actual = btn.getAttribute('aria-disabled') === 'true';

    // Salir si no cambio nada. Sin esto el observer se retroalimenta: escribir
    // un atributo genera una mutacion aunque el valor sea el mismo, y eso
    // vuelve a disparar sync en bucle hasta colgar la pestana.
    if (btn.disabled === bloqueado && actual === bloqueado) return;

    btn.disabled = bloqueado;
    if (bloqueado) {
      btn.setAttribute('aria-disabled', 'true');
    } else {
      btn.removeAttribute('aria-disabled');
    }
  }

  function watch(btn) {
    var form = formOf(btn);
    if (!form) return;
    var scope = form.closest('product-form') || form;
    // El theme re-renderiza el bloque al cambiar de variante, asi que se observa
    // el contenedor entero y no solo el boton, que puede ser reemplazado.
    new MutationObserver(function () {
      sync(btn);
    }).observe(scope, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class']
    });
    form.addEventListener('change', function () {
      setTimeout(function () {
        sync(btn);
      }, 0);
    });
    sync(btn);
  }

  function onClick(event) {
    event.preventDefault();
    event.stopPropagation();

    var btn = event.currentTarget;
    var form = formOf(btn);
    if (!form) return;

    // Ultima red de seguridad, por si el estado cambio entre el ultimo
    // sync y el clic.
    var add = addButtonOf(btn);
    if (add && (add.disabled || add.getAttribute('aria-disabled') === 'true')) {
      sync(btn);
      return;
    }

    // El theme deja .product-variant-id deshabilitado hasta que hay una
    // combinacion valida, por eso FormData no lo incluye y lo pasamos a mano.
    var variantInput = variantInputOf(form);
    if (!variantInput || !variantInput.value) {
      showError(btn, btn.getAttribute('data-error-variant'));
      return;
    }

    if (variantIsUnavailable(form)) {
      sync(btn);
      showError(btn, btn.getAttribute('data-error-unavailable'));
      return;
    }

    var body = new FormData(form);
    body.set('id', variantInput.value);
    if (!body.get('quantity')) body.set('quantity', '1');

    clearError(btn);
    setBusy(btn, true);

    fetch(route('/cart/add.js'), {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || '');
          return data;
        });
      })
      .then(function () {
        window.location.href = route('/cart');
      })
      .catch(function (err) {
        setBusy(btn, false);
        showError(btn, err.message || btn.getAttribute('data-error-generic'));
      });
  }

  function init(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('.cx-buy-now:not([data-cx-bound])');
    Array.prototype.forEach.call(buttons, function (btn) {
      btn.setAttribute('data-cx-bound', '1');
      btn.addEventListener('click', onClick);
      watch(btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // El theme re-renderiza secciones al cambiar variante y en el personalizador.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
